export const PrivacyPolicy = {
  Header: {
    Title: 'プライバシーポリシー',
  },
};
